module.exports = __webpack_public_path__ + "img/pepper-hot.189631ba.svg";